import {
    request
} from './request.js'

// 任务通知接口
export function taskNotification(data) {
    return request({
        url: `/api/infrastructure/task/taskNotification`,
        method: 'post',
        data,
    })
}


// WEBPACK FOOTER //
// ./src/network/websocket.js